/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  UpdateBotByIdOptions,
  UpdateBotByIdStatus200,
  UpdateBotByIdStatus400,
  UpdateBotByIdStatus404,
  UpdateBotByIdStatus500,
} from '../types/UpdateBotById'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { updateBotById } from '../clients/updateBotById'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const updateBotByIdMutationKey = () => [{ url: '/v1/bots/:bot_id' }] as const

export function updateBotByIdMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = updateBotByIdMutationKey()
  return mutationOptions<
    UpdateBotByIdStatus200,
    ResponseErrorConfig<UpdateBotByIdStatus400 | UpdateBotByIdStatus404 | UpdateBotByIdStatus500>,
    UpdateBotByIdOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ path, body }) => {
      return updateBotById({ ...config, path, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @summary Update bot by ID
 * {@link /v1/bots/:bot_id}
 */
export function useUpdateBotById<TContext>(
  options: {
    mutation?: UseMutationOptions<
      UpdateBotByIdStatus200,
      ResponseErrorConfig<UpdateBotByIdStatus400 | UpdateBotByIdStatus404 | UpdateBotByIdStatus500>,
      UpdateBotByIdOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? updateBotByIdMutationKey()

  const baseOptions = updateBotByIdMutationOptions(config) as UseMutationOptions<
    UpdateBotByIdStatus200,
    ResponseErrorConfig<UpdateBotByIdStatus400 | UpdateBotByIdStatus404 | UpdateBotByIdStatus500>,
    UpdateBotByIdOptions,
    TContext
  >

  return useMutation<
    UpdateBotByIdStatus200,
    ResponseErrorConfig<UpdateBotByIdStatus400 | UpdateBotByIdStatus404 | UpdateBotByIdStatus500>,
    UpdateBotByIdOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    UpdateBotByIdStatus200,
    ResponseErrorConfig<UpdateBotByIdStatus400 | UpdateBotByIdStatus404 | UpdateBotByIdStatus500>,
    UpdateBotByIdOptions,
    TContext
  >
}
